import React from 'react';
import classNames from 'classnames';
import Navigation, { BaseNavigationProps } from './BaseNavigation';

const FolderTabs = ({ className, ...rest }: BaseNavigationProps) => <Navigation className={classNames(className, 'folder-tabs')} {...rest} />;

export default FolderTabs;
